import React, { Component } from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import './hotel-map-location.css';
import { GoogleApiWrapper, InfoWindow, Map, Marker } from 'google-maps-react';
import MapsClient from '../../../../api/maps';

class HotelMapLocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      destinationName: '',
    };
    this.getNameLocation = this.getNameLocation.bind(this);
  }

  componentDidMount() {
    this.getNameLocation();
  }

  getNameLocation() {
    MapsClient.getInfoByLatLng(`${this.props.hotel.latitud},${this.props.hotel.longitud}`).then((res) => {
      if (res !== 'invalid request') {
        if (res.status === 200 && res.data.status === 'OK') {
          const addressInformation = res.data.results[0].address_components;
          let direccion = 'No localizada';
          if (addressInformation[5] !== undefined) {
            direccion = `${addressInformation[1].long_name} ${addressInformation[0].long_name} ,${addressInformation[2].long_name} , ${addressInformation[4].long_name} , ${addressInformation[5].long_name}.`;
          }
          this.setState({
            destinationName: direccion,
          });
        } else {
          this.setState({
            destinationName: 'No localizada',
          });
        }
      } else {
        this.setState({
          destinationName: 'No localizada',
        });
      }
    });
  }

  render() {
    const defaultProps = {
      center: { lat: parseFloat(this.props.hotel.latitud), lng: parseFloat(this.props.hotel.longitud) },
      zoom: 15,
    };
    const style = {
      width: '100%',
      height: '20em',
    };
    const iconMarker = new isClient && window.google.maps.MarkerImage(
      `${process.env.RAZZLE_URL}/assets/img/hotel_map_marker.png`,
      null, /* size is determined at runtime */
      null, /* origin is 0,0 */
      null, /* anchor is bottom center of the scaled image */
      new isClient && window.google.maps.Size(35, 40),
    );
    return (
      <div className='seccion-map-hotels'>
        <div className='panel panel-default custom bordeado'>
          <div className='panel-body'>
            <div className='row'>
              <div className='col-lg-8 hotel-map'>
                <Map
                  item
                  xs={12}
                  style={style}
                  google={this.props.google}
                  zoom={15}
                  initialCenter={defaultProps.center}
                >
                  <Marker
                    title={this.props.hotel.nombre}
                    name={this.state.destinationName}
                    position={defaultProps.center}
                    icon={iconMarker}
                  >
                    <InfoWindow
                      marker={{}}
                      visible={true}
                    >
                      <div>
                        <h1>sarasa</h1>
                      </div>
                    </InfoWindow>
                  </Marker>
                </Map>
              </div>
              <div className='col-lg-4 direction'>
                <h2>Direccion: </h2>
                <p>{this.state.destinationName}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
export default GoogleApiWrapper({
  apiKey: (process.env.RAZZLE_GOOGLE_MAPS_API_KEY),
  language: 'es',
})(HotelMapLocation);
